module.exports = __webpack_public_path__ + "static/img/createCode.fb1f7204.png";